import React from 'react';
import FeaturedAuthorTutoring from '../FeaturedAuthorTutoring';

import imageSrc from './brandon.jpg';

const BrandonTutoring = () => {
  return (
    <FeaturedAuthorTutoring
      imageSrc={imageSrc}
      description="Need help improving your chances of passing a FINRA or NASAA exam? Book a remote private tutoring session with Brandon Rith, author of the Achievable programs for the FINRA SIE and Series exams. With 15 years of industry experience and 10 years of professional teaching experience, Brandon can help you build the necessary knowledge to pass finance exams with confidence. He can tutor through your entire study period or even provide some quick support just prior to the exam. Special discounts for Achievable students."
      url="https://basicwisdom.net/?utm_source=achievable"
      cta="Visit Brandon's site"
    />
  );
};

export default BrandonTutoring;
